module.exports = __webpack_public_path__ + "img/영등포역 미용실.3c215722.png";